(function () {
  function convertVariantDropdownsToButtons() {
    document.querySelectorAll('.Avada-BundleCard__VariantDropdown').forEach(select => {
      if (select.dataset.avadaBtnDone) return;
      select.dataset.avadaBtnDone = '1';

      const wrap = document.createElement('div');
      wrap.className = 'Avada-BundleCard__VariantBtnGroup';

      [...select.options].forEach(opt => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.textContent = opt.value;
        btn.disabled = opt.disabled;
        btn.className = 'Avada-BundleCard__VariantBtn' + (opt.selected ? ' is-selected' : '');
        btn.onclick = () => {
          select.value = opt.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
          wrap.querySelectorAll('button').forEach(b => b.classList.remove('is-selected'));
          btn.classList.add('is-selected');
        };
        wrap.appendChild(btn);
      });

      select.style.display = 'none';
      select.insertAdjacentElement('afterend', wrap); // chèn ngay sau select, không cần biết wrapper class
    });
  }

  // Chạy ngay lần đầu (desktop: select đã có sẵn trong DOM)
  convertVariantDropdownsToButtons();

  // Theo dõi DOM để bắt select mới xuất hiện (mobile: select chỉ tồn tại khi modal được mở ra)
  let debounceTimer;
  const observer = new MutationObserver(() => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(convertVariantDropdownsToButtons, 300);
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();